import * as React from 'react'

import { Box, Touchable } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Coffee, Moon, Office, Salad } from '@factorialco/f0-react/icons/app'

export type ExclusionType =
  | 'breakfastProvided'
  | 'lunchProvided'
  | 'dinnerProvided'
  | 'accommodationProvided'

const EXCLUSION_ICONS: Record<ExclusionType, typeof Coffee> = {
  breakfastProvided: Coffee,
  lunchProvided: Salad,
  dinnerProvided: Moon,
  accommodationProvided: Office,
}

interface ExclusionToggleButtonProps {
  type: ExclusionType
  isActive: boolean
  onToggle: () => void
  disabled?: boolean
}

const ExclusionToggleButton = ({
  type,
  isActive,
  onToggle,
  disabled = false,
}: ExclusionToggleButtonProps) => {
  const IconComponent = EXCLUSION_ICONS[type]

  return (
    <Touchable onClick={disabled ? undefined : onToggle} disabled={disabled}>
      <Box
        width="s140"
        height="s48"
        borderRadius={{ all: 'abs008' }}
        background={disabled ? 'grey100' : isActive ? 'viridian100' : 'white'}
        justifyContent="center"
        alignItems="center"
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: disabled ? 'grey200' : isActive ? 'viridian600' : 'grey300',
          },
        }}
        style={disabled ? { cursor: 'not-allowed', opacity: '0.5' } : undefined}
      >
        <F0Icon
          icon={IconComponent}
          size="md"
          color={disabled ? 'secondary' : isActive ? 'default' : 'bold'}
        />
      </Box>
    </Touchable>
  )
}

export default ExclusionToggleButton
